class BisModalDialog extends HTMLElement {
  constructor() {
    super();
    this.bisContainer = this;
    this.moveBisModal();

    this.bisModalTrigger = document.querySelector('.bis-modal-trigger');
    this.bisModalTrigger.addEventListener('click', this.onToggleClick.bind(this));

    this.closeButton = this.querySelector('.bis-modal__close');
    this.closeButton.addEventListener('click', this.close.bind(this));

    this.bisForm = this.querySelector('#sf-contact');
    this.variantInput = this.querySelector('input[name="sf_Product_variant__c"]');
    this.priceInput = this.querySelector('input[name="sf_Product_Price__c"]');

    this.loadingMessage = this.querySelector('.bis-modal__loading-message');
    this.contactFields = this.querySelector('.bis-modal__form-fields');
    this.contactFieldsInputs = this.contactFields.querySelectorAll('.field__input');
    this.resultMessage = document.getElementById('bis-modal-results-message');
    this.resultText = this.querySelector('.bis-modal__result-text');

    this.bisContainer.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') {
        this.close();
      }
    });

    this.bisForm.addEventListener('submit', this.onFormSubmit.bind(this));
  }

  variantChangeUnsubscriber = undefined;

  connectedCallback() {
    this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      event.data.variant.available ? this.disableBIS(event.data) : this.enableBIS(event.data)
    });
  }

  disconnectedCallback() {
    if (this.variantChangeUnsubscriber) {
      this.variantChangeUnsubscriber();
    }
  }

  moveBisModal() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  onToggleClick(event) {
    event.preventDefault();
    this.bisContainer.hasAttribute('open') ? this.close() : this.open(event);
  }

  open() {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    this.bisContainer.setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.querySelector('[tabindex="-1"]');
        const focusElement = this.querySelector('.bis-modal__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.bisModalTrigger : null);
    this.bisContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
    this.revertModal()
  }

  revertModal() {    
    if (this.contactFields) {
      this.contactFields.style.display = 'block';

      this.contactFieldsInputs.forEach((item) => {
        item.value = ''
      });
    }

    if (this.resultMessage && this.resultText) {
      this.resultText.textContent = '';
      this.resultMessage.style.display = 'none';
      this.resultMessage.classList.remove('success', 'error');  
    }
  }

  onBodyClick(event) {
    if (event.target.classList.contains('bis-modal__overlay')) {
      this.close(false);
    }
  }

  disableBIS(data) {
    this.bisModalTrigger.disabled = true;
    this.variantInput.value = data.variant.id;
  }

  enableBIS(data) {
    this.bisModalTrigger.disabled = false;
    this.variantInput.value = data.variant.id;
  }

 onFormSubmit(event) {
    event.preventDefault();

    if (this.loadingMessage) {
        this.loadingMessage.style.display = 'block';
    }

    const xhttp = new XMLHttpRequest();

    xhttp.onreadystatechange = () => {
        if (xhttp.readyState === 4) {
            if (this.loadingMessage) {
                this.loadingMessage.style.display = 'none';
            }

            if (xhttp.status == 200) {
                const result = JSON.parse(xhttp.responseText);

                if (result && result.success && result.id) {
                    this.showResult(true, "Thank you for your interest!");
                } else {
                    this.showResult(false, "There was an error processing your request. Please try again later.");
                }
            } else {
                this.showResult(false, "There was an error processing your request. Please try again later.");
            }
        }
    };

    // Get form values
    const formElements = event.target.elements;

    // Get the raw price string and remove non-numeric characters (except the dot)
    let rawPrice = formElements["sf_Product_Price__c"].value;
    let cleanedPrice = rawPrice.replace(/[^0-9\.]+/g, "");
    let productPrice = parseFloat(cleanedPrice);
    
    // Validate and round price
    const roundedPrice = isNaN(productPrice) ? 0 : Math.round(productPrice);

    let urlstr = "https://www.deltafaucet.com/salesforce-PrdAwsSecret.php?";
    urlstr += "ModelNo__c=" + encodeURIComponent(formElements["sf_ModelNo__c"].value);
    urlstr += "&Product_variant__c=" + encodeURIComponent(formElements["sf_Product_variant__c"].value);
    urlstr += "&Product_Price__c=" + encodeURIComponent(roundedPrice); // Use rounded price
    urlstr += "&RecordType__c=" + encodeURIComponent(formElements["sf_RecordType__c"].value);
    urlstr += "&Agency__c=" + encodeURIComponent(formElements["sf_Agency__c"].value);
    urlstr += "&Subscriber_Status__c=" + encodeURIComponent(formElements["sf_Subscriber_Status__c"].value);
    urlstr += "&Subscription2__c=" + encodeURIComponent(formElements["sf_Subscription2__c"].value);
    urlstr += "&Source_of_Registration__c=" + encodeURIComponent(formElements["sf_Source_of_Registration__c"].value);
    urlstr += "&FirstName__c=" + encodeURIComponent(formElements["sf_FirstName__c"].value);
    urlstr += "&LastName__c=" + encodeURIComponent(formElements["sf_LastName__c"].value);
    urlstr += "&Email__c=" + encodeURIComponent(formElements["sf_Email__c"].value);

    xhttp.open("GET", urlstr, true);
    xhttp.send();

    return false;
}


  showResult(success, text) {
    if (this.contactFields) {
      this.contactFields.style.display = 'none';
    }

    if (this.resultMessage && this.resultText) {
      this.resultText.textContent = text;
      this.resultMessage.style.display = 'block';
      this.resultMessage.className = success ? 'success' : 'error';
    }
  }
}

customElements.define('bis-modal-dialog', BisModalDialog);